import { render, staticRenderFns } from "./TicketOrderProxy.vue?vue&type=template&id=bdf43ac0"
import script from "./TicketOrderProxy.vue?vue&type=script&lang=js"
export * from "./TicketOrderProxy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports